import { createAction } from 'redux-actions';

export const addBreadcrumb = createAction('ADD_BREADCRUMB');
export const removeBreadcrumb = createAction('REMOVE_BREADCRUMB');
export const addCookies = createAction('ADD_COOKIES');
export const rememberEditCookies = createAction('REMEMBER_EDIT_COOKIE');
